import { extend, localize } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import en from "../assets/validations/lang/en.json"
import am from "../assets/validations/lang/am.json";

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

localize({
    am: {messages: am.messages},
    en: {messages: en.messages}
});